import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import BuyerAssurance from 'dibs-vg/dist/react/buyer-assurance';
import classnames from 'classnames';
import styles from './PdpSharedBuyerProtectionBox.scss';

export function PdpSharedBuyerProtectionBox({ isTrade, withImage }) {
    const readMoreHref = isTrade ? '/info/trade/promise/' : '/about/promise/';

    const wrapperClassName = classnames(styles.wrapper, {
        [styles.isFixed]: withImage,
        rowFlex: withImage,
    });
    const copyClassName = classnames(styles.copy, {
        colXs9: withImage,
    });

    return (
        <div className={wrapperClassName} data-tn="buyer-protection-wrrapper">
            {withImage && <div className={`${styles.image} colXs3`} />}
            <div className={copyClassName}>
                <div className={styles.title} data-tn="buyer-protection-title">
                    <BuyerAssurance className={styles.icon} />
                    <FormattedMessage
                        id="PdpSharedBuyerProtectionBox.title"
                        defaultMessage="Buyer Protection Guaranteed"
                    />
                </div>
                <div className={styles.message} data-tn="buyer-protection-message">
                    <span className={styles.messageBold}>
                        <FormattedMessage
                            id="PdpSharedBuyerProtectionBox.promiseMessage"
                            defaultMessage="Our Promise To You:"
                        />
                    </span>{' '}
                    <FormattedMessage
                        id="PdpSharedBuyerProtectionBox.message"
                        defaultMessage="If you're not happy with the way an item arrived, we'll work with you and the seller to reach an optimal resolution."
                    />{' '}
                    <a
                        href={readMoreHref}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-tn="buyer-protection-link"
                    >
                        <FormattedMessage
                            id="PdpSharedBuyerProtectionBox.readMoreLink"
                            defaultMessage="Read more"
                        />
                    </a>
                </div>
            </div>
        </div>
    );
}

PdpSharedBuyerProtectionBox.propTypes = {
    isTrade: PropTypes.bool,
    withImage: PropTypes.bool,
};
